import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ComputersFacade } from 'mbs-ui-shared@facades/computers.facade';
import { EnvironmentService } from 'mbs-ui-shared@services/environments.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Will update computer entity in case of ServiceUnavailable (408) error during rm command request
 */
@Injectable()
export class RmCommandServiceUnavailableInterceptor implements HttpInterceptor {
  private environment = inject(EnvironmentService);
  private computerFacade = inject(ComputersFacade);

  public selectedHid = '';

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const includedCommands = ['/commands/invokecommand', '/commands/invokepscommand', '/commands/invokeactivecommand'];
    const isIncludedByCommand = includedCommands.some((command) => req.url.includes(command));

    return next.handle(req).pipe(
      catchError((e) => {
        if (e.status === HttpStatusCode.RequestTimeout && this.environment.production && isIncludedByCommand) {
          const regExp = /(%7B|\{)(.*)(%7D|\})/;
          const regExpSecond = /(.*)(rm\/)(.*)(\/commands)/;
          const getFirst = regExp.exec(req.url);
          const getSecond = regExpSecond.exec(req.url);

          const hid = getFirst?.length ? getFirst[2] : getSecond[3];

          this.computerFacade.loadComputerByHid({ hid: `${hid}`, quiet: false, force: true });
        }

        throw e;
      })
    );
  }
}
